import client from './client';

export const coachProfileApi = {
  // Own profile
  getOwn: () => client.get('/coach-profile/me'),
  updateOwn: (data) => client.put('/coach-profile/me', data),

  // Public profiles
  getByUsername: (username) => client.get(`/coach-profile/public/${username}`),
  getById: (coachId) => client.get(`/coach-profile/by-id/${coachId}`),
  listCoaches: (acceptsOnly = false) =>
    client.get('/coach-profile/coaches', { params: { accepts_only: acceptsOnly } }),

  // Hire requests
  sendRequest: (coachId, message = '') =>
    client.post('/coach-profile/requests', { coach_id: coachId, message }),
  getRequests: (status) =>
    client.get('/coach-profile/requests', { params: status ? { status } : {} }),
  getMyRequest: (coachId) =>
    client.get(`/coach-profile/my-request/${coachId}`),
  respondToRequest: (requestId, action) =>
    client.patch(`/coach-profile/requests/${requestId}`, { action }),
};
